import { StartYourClaimForm } from "./Form";
import useStartYourClaim from "./hooks/useStartYourClaim";

export const StartYourClaim = () => {
  const props = useStartYourClaim();
  return <StartYourClaimForm {...props} />;
};

export default StartYourClaim;
